import {getHistory} from "../indexedDb/historyDb";


export default {
  namespaced: true,

  state: {
    historyList: [],
  },

  mutations: {
    setHistory(state, historyList) {
      state.historyList = historyList;
    },
  },

  actions: {
    async getHistoryList({commit}) {
      const history = await getHistory();

      console.log('history list', history);

      commit('setHistory', history);
    },
  },

  getters: {},


}
